import { Component, HostListener, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { environment } from "src/environments/environment";
import { UserService } from "./services/user.service";
import Hotjar from "@hotjar/browser";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "bilgesin";
  state = "";
  _isLayout = true;

  latestSurveyHref = "";
  showLatestSurveyHref = false;
  latestSurveyClickCount = 0;

  get isLayout() {
    return this._isLayout;
  }
  set isLayout(value: boolean) {
    this._isLayout = value;
    setTimeout(() => {
      this.updateBodyPaddingTop();
    }, 250);
  }

  msgText =
    "Merhaba, Bilgesin.com aracılığı ile iletişime geçiyorum. Size danışmak istediğim bir konu var.";

  constructor(private router: Router, userService: UserService) {
    userService.controlUnderConstruction();
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.state = val.url;
        this.isLayout = true;

        if (
          val.url == "/login" ||
          val.url == "/forgot-password" ||
          val.url.indexOf("/admin") > -1 ||
          val.url == "/email-verification-success" ||
          val.url === "/under-construction"
        ) {
          this.isLayout = false;
        } else {
          this.isLayout = true;
        }
        userService.controlUnderConstruction();

        this.getLatestSurveyHref();
        this.checkShowLatestSurveyHref();
      }
    });
    userService.user.subscribe((x) => {
      if (x) {
        this.isLayout = true;
      }
    });
    setTimeout(() => {
      // window['FB'].login();
    }, 3000);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.updateBodyPaddingTop();
    }, 250);
    this.addGtm();
    this.checkReferrer();
    this.addHotjar();

    this.getLatestSurveyHref();
    this.checkShowLatestSurveyHref();
  }

  checkReferrer() {
    if (environment.hostName() !== "bilgesiniz.com") return;
    if (document.referrer.indexOf("google.com") === -1) return;

    window.location.href = "https://bilgesin.com";
  }

  addGtm() {
    if (environment.hostName() !== "bilgesin.com") {
      return;
    }

    const s = document.createElement("script");
    s.type = "text/javascript";
    s.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PVWRQBD');
    `;
    s.id = "gtm-head";
    document.getElementsByTagName("head")[0].appendChild(s);

    const nos = document.createElement("noscript");
    nos.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PVWRQBD"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    nos.id = "gtm-body";
    document.getElementsByTagName("body")[0].appendChild(nos);
  }

  addHotjar() {
    if (environment.hostName() !== "bilgesin.com") {
      return;
    }

    const siteId = 3806990;
    const hotjarVersion = 6;

    Hotjar.init(siteId, hotjarVersion);
  }

  @HostListener("window:resize", [])
  onResize() {
    this.updateBodyPaddingTop();
  }

  @HostListener("window:storage", [])
  onStorageChange() {
    this.getLatestSurveyHref();
    this.checkShowLatestSurveyHref();
  }

  updateBodyPaddingTop() {
    const headerHolderElm = document.querySelector(".header-holder");
    const pt = this.isLayout ? (headerHolderElm?.clientHeight || 1) - 1 : 0;
    document.querySelector("body").style.paddingTop = `${pt}px`;
  }

  getLatestSurveyHref() {
    const surveyDataStr = window.localStorage.getItem("latestSurveyHref");

    if (!surveyDataStr) {
      this.latestSurveyHref = "";
      this.latestSurveyClickCount = 0;
      return;
    }

    // Try to parse as JSON (new format)
    try {
      const surveyData = JSON.parse(surveyDataStr);
      const createdAt = new Date(surveyData.createdAt);
      const now = new Date();
      const oneMonthAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      const clickCount = surveyData.clickCount || 0;

      if (createdAt < oneMonthAgo || clickCount > 5) {
        window.localStorage.removeItem("latestSurveyHref");
        window.localStorage.removeItem("latestSurveyResults");
        window.localStorage.removeItem("latestSurveyOtherResults");
        this.latestSurveyHref = "";
        this.latestSurveyClickCount = 0;
      } else {
        this.latestSurveyHref = surveyData.href || "";
        this.latestSurveyClickCount = clickCount;
      }
    } catch (e) {
      // Legacy format (plain string) - migrate to new format
      this.latestSurveyHref = surveyDataStr;
      this.latestSurveyClickCount = 0;

      // Migrate to new format
      const surveyData = {
        href: surveyDataStr,
        createdAt: new Date().toISOString(),
        clickCount: 0,
      };
      window.localStorage.setItem(
        "latestSurveyHref",
        JSON.stringify(surveyData)
      );
    }
  }

  checkShowLatestSurveyHref() {
    this.showLatestSurveyHref =
      !this.getActivatedComponent()?.hideLatestSurveyHref;
  }

  goToLatestSurvey() {
    if (!this.latestSurveyHref) return;
    this.incrementSurveyClickCount();
    this.router.navigateByUrl(this.latestSurveyHref);
  }

  incrementSurveyClickCount() {
    const surveyDataStr = window.localStorage.getItem("latestSurveyHref");

    if (!surveyDataStr) {
      return;
    }

    try {
      const surveyData = JSON.parse(surveyDataStr);
      surveyData.clickCount = (surveyData.clickCount || 0) + 1;
      window.localStorage.setItem(
        "latestSurveyHref",
        JSON.stringify(surveyData)
      );
      this.latestSurveyClickCount = surveyData.clickCount;
    } catch (e) {
      // If parsing fails, it's legacy format - do nothing
      console.error("Failed to increment click count:", e);
    }
  }

  // Method to get the activated component information
  getActivatedComponent(): any {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.component;
  }
}
